import { __require as r } from "../bundled_deps/.pnpm/@intercom_intercom-sanitizer@3.0.0_@braintree_sanitize-url@7.0.2_isomorphic-dompurify@2.34.0/bundled_deps/@intercom/intercom-sanitizer/dist/index.js";
var i = r();
export {
  i as d
};
